import React from 'react';
import { TableCell, Box } from '@mui/material';
import { useStateSelector } from '../../context/StateSelectors';

const GridUploadCell = ({ value, field, ...other }) => {
    const contextImages = useStateSelector((state) => state.images);
    if (!contextImages) return null;
    const renderFilePreview = (fileName) => {
        const imageURL = contextImages[fileName];

        if (!imageURL) return null;

        return (
            <img
                loading={'lazy'}
                src={imageURL}
                alt={fileName}
                style={{
                    width: '32px',
                    height: '32px',
                    objectFit: 'cover',
                    borderRadius: '6px'
                }}
            />
        );
    };

    const files = Array.isArray(value) ? value : [value];
    const visibleFiles = files.slice(0, 2);
    const remainingCount = files.length - visibleFiles.length;
    return (
        <TableCell key={field.id} align="left">
            <Box
                display="flex"
                alignItems="center"
                sx={{ width: remainingCount ? '114px' : '100%' }}
            >
                {visibleFiles.map((file, index) =>
                    file ? (
                        <Box sx={{ flexShrink: 0, mr: '6px' }} key={index}>
                            {renderFilePreview(file.name)}
                        </Box>
                    ) : null
                )}
                {remainingCount > 0 && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '6px',
                            backgroundColor: '#f0f0f0',
                            color: '#555',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            flexShrink: 0
                        }}
                    >
                        +{remainingCount}
                    </Box>
                )}
            </Box>
        </TableCell>
    );
};

export default GridUploadCell;
